import { getAxiosInstance } from "../ApiConfig";

async function FetchAllCallLog(page, user) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllRelatedCalllog/${page}/${user}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CallLogDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/callLog/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteCallLogId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/callLog/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CalllogSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/saveCallLog`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CalllogUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/callLog/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TwilioCalllogUpdate(description, callTitle, mobileNumber, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCallLogFromTwilio/${description}/${callTitle}/${mobileNumber}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCallLogFromTwilio(entityId, entityType, mobileNumber) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCallLogFromTwilio/${entityId}/${entityType}/${mobileNumber}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchAllCallLog,
    CallLogDetailData,
    deleteCallLogId,
    CalllogUpdate,
    CalllogSave,
    TwilioCalllogUpdate,
    getCallLogFromTwilio,
}